import {
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from 'react';
import isNil from 'lodash/isNil';

function usePersistentState<T>(defaultValue: T, key: string): [T, Dispatch<SetStateAction<T>>] {
  const _value = localStorage.getItem(key);
  const [value, dispatcher] = useState<T>(
    !isNil(_value)
      ? JSON.parse(_value)
      : defaultValue,
  );

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value ?? defaultValue));
  }, [key, value, defaultValue]);

  return [value, dispatcher];
}

export default usePersistentState;
